
export default (inputData) =>{
  	const queryName = inputData.fakturaAssist;
  	const names = Object.keys(queryName || {}).filter((item) => item !== '__typename');
  return names.length > 1 ? queryName : queryName[names[0]];
};

